import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverLoanLibraryQueueApi {
    static getUserQueue() {
        return sendRequest(
            requestOptions(config.URL + `loan-library/queue`,
                requestTypes.GET,
            ),
        );
    }

    static addToQueue(catalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/queue`,
                requestTypes.POST,
                JSON.stringify({ LoanLibraryCatalogItemId: catalogItemId }),
                apiConstants.successMessage.queue.ADD,
            ),
        );
    }

    static assignShippingLocation(loanLibraryQueueAssignment: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/queue/assign-shipping`,
                requestTypes.PUT,
                JSON.stringify(loanLibraryQueueAssignment),
                apiConstants.successMessage.queue.UPDATE,
            ),
        );
    }

    static deleteQueueItem(loanLibraryQueueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/queue/${loanLibraryQueueItemId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.queue.DELETE
            ),
        );
    }

    static getShippingLocations() {
        return sendRequest(
            requestOptions(config.URL + `shipping-locations`,
                requestTypes.GET,
            ),
        );
    }
}

export const loanLibraryQueueApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryQueueApi : serverLoanLibraryQueueApi;

